import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL || "http://localhost:5000",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  reducerPath: "naariApi",
  tagTypes: ["User", "DocRep", "RxRecord", "WeeklyRecord", "PspRecord", "LycoredRecord", "AdminStats", "AmStats", "AmTeam"],
  endpoints: (build) => ({
    // Auth
    login: build.mutation({
      query: (body) => ({ url: "/auth/login", method: "POST", body }),
    }),
    getProfile: build.query({
      query: () => "/auth/profile",
      providesTags: ["User"],
    }),

    // DocRep
    getDocRep: build.mutation({
      query: (body) => ({ url: "/docrep/docrep", method: "POST", body }),
    }),

    // MR Trackers
    submitRx: build.mutation({
      query: (formData) => ({ url: "/naari/rx", method: "POST", body: formData }),
      invalidatesTags: ["RxRecord"],
    }),
    submitWeekly: build.mutation({
      query: (formData) => ({ url: "/naari/weekly", method: "POST", body: formData }),
      invalidatesTags: ["WeeklyRecord"],
    }),
    submitPsp: build.mutation({
      query: (formData) => ({ url: "/naari/psp", method: "POST", body: formData }),
      invalidatesTags: ["PspRecord"],
    }),
    submitLycored: build.mutation({
      query: (formData) => ({ url: "/naari/lycored", method: "POST", body: formData }),
      invalidatesTags: ["LycoredRecord"],
    }),
    getMySubmissions: build.mutation({
      query: (body) => ({ url: "/naari/my-submissions", method: "POST", body }),
    }),
    getMyStats: build.mutation({
      query: (body) => ({ url: "/naari/my-stats", method: "POST", body }),
    }),

    // AM
    getAmTeam: build.mutation({
      query: (body) => ({ url: "/naari/am/team", method: "POST", body }),
    }),
    getAmStats: build.mutation({
      query: (body) => ({ url: "/naari/am/stats", method: "POST", body }),
    }),
    getAmMrSubmissions: build.mutation({
      query: (body) => ({ url: "/naari/am/mr-submissions", method: "POST", body }),
    }),

    // Admin
    getAdminStats: build.query({
      query: () => "/naari/admin/stats",
      providesTags: ["AdminStats"],
    }),
    getAdminSubmissions: build.mutation({
      query: (body) => ({ url: "/naari/admin/submissions", method: "POST", body }),
    }),
    getAdminUsers: build.query({
      query: () => "/naari/admin/users",
      providesTags: ["User"],
    }),
    createUser: build.mutation({
      query: (body) => ({ url: "/naari/admin/users", method: "POST", body }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const {
  useLoginMutation,
  useGetProfileQuery,
  useGetDocRepMutation,
  useSubmitRxMutation,
  useSubmitWeeklyMutation,
  useSubmitPspMutation,
  useSubmitLycoredMutation,
  useGetMySubmissionsMutation,
  useGetMyStatsMutation,
  useGetAmTeamMutation,
  useGetAmStatsMutation,
  useGetAmMrSubmissionsMutation,
  useGetAdminStatsQuery,
  useGetAdminSubmissionsMutation,
  useGetAdminUsersQuery,
  useCreateUserMutation,
} = api;
